export default "__VITE_ASSET__Dpsy3Y1J__"